import { createFileRoute } from '@tanstack/react-router';

type Search = {
  appointmentTypeId?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/schedule/availability')({
  validateSearch: (search: Search): Search => {
    return {
      appointmentTypeId: search.appointmentTypeId || undefined,
    };
  },
});
